module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/lattice.7746457a1b99ffd741f5a607a2fe7ac1.png";